import { Star } from "lucide-react";

export function StarRating({ rating, reviews, className = "" }) {
  const safeRating = typeof rating === "number" ? rating : parseFloat(rating || 0);
  const safeReviews = typeof reviews === "number" ? reviews : parseInt(reviews || 0, 10);
  return (
    <div className={`inline-flex items-baseline gap-1.5 tabular-nums ${className}`}>
      <Star size={12} className="translate-y-[1px]" fill="#F4B860" stroke="#F4B860" />
      <span className="text-ink text-sm font-medium">{safeRating.toFixed(1)}</span>
      <span className="text-ink-muted text-xs">({safeReviews})</span>
    </div>
  );
}
